import axiosInstance from "./AxiosInstance";

class SettingsService {
  // Get WhatsApp policy status
  async getWhatsAppPolicy() {
    try {
      const response = await axiosInstance.get(
        "/api/v3/core/politicas_whatsapp/",
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Accept WhatsApp policy
  async acceptWhatsAppPolicy() {
    try {
      const response = await axiosInstance.post(
        "/api/v3/core/politicas_whatsapp/",
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Get Data Treatment policy status
  async getDataPolicy() {
    try {
      const response = await axiosInstance.get(
        "/api/v3/core/politicas-tratamiento-datos/",
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Accept Data Treatment policy
  async acceptDataPolicy() {
    try {
      const response = await axiosInstance.post(
        "/api/v3/core/politicas-tratamiento-datos/",
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const settingsService = new SettingsService();
export default settingsService;
